import React, { useState, useEffect } from 'react';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { BiLoaderAlt } from 'react-icons/bi';
export type ButtonTypes =
  | 'primary'
  | 'ghost'
  | 'dashed'
  | 'link'
  | 'text'
  | 'default';
export interface ButtonProps {
  onKeyPress?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
  shape?: 'circle' | 'squre';
  type?: ButtonTypes;
  color?: string;
  Icon?: typeof React.Component | React.ComponentType;
  title?: string | JSX.Element;
  bg?: 'primary' | 'secondary' | string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  prefix?: JSX.Element | null;
  suffix?: JSX.Element | null;
  loading?: boolean;
  width?: string;
}

const Button = ({
  title,
  Icon,
  shape = 'squre',
  color = 'white',
  bg = 'primary',
  onKeyPress,
  onClick,
  disabled,
  prefix,
  loading,
  width,
  suffix,
  type = 'primary',
}: ButtonProps) => {
  const [typeState, setTypeState] = useState('');

  useEffect(() => {
    let newTypeState = `font-normal text-center text-xs p-1 xl:p-2  h-auto xl:h-9 md:h-7 w-${
      width || 'auto'
    }  ${
      shape === 'circle' ? 'rounded-full' : 'rounded-md'
    }   hover:bg-opacity-70   skip-focus`; // 'bg-primary'
    switch (type) {
      case 'text':
        newTypeState =
          newTypeState +
          ` bg-transparent ${'hover:bg-' + (bg || 'ring-color')}  ${
            disabled ? 'text-gray-300' : 'text-' + color
          }`;
        break;
      case 'ghost':
        newTypeState =
          newTypeState +
          ` bg-transparent
         border hover:bg-gray-200
           ${'text-' + color}`;
        break;
      case 'default':
        newTypeState =
          newTypeState +
          ` ${disabled ? 'bg-gray-300' : 'bg-transparent  shadow-none'}
           border ${'border-' + bg}
           ${'text-' + bg}  hover:text-primary`;
        break;
      case 'primary':
        newTypeState =
          newTypeState +
          `
           ${disabled ? 'bg-gray-300' : `bg-${bg} shadow-sm `}
             border-gray-300
             ${'text-' + color}`;
        break;
    }
    setTypeState(newTypeState);
  }, [type, bg, color, disabled]);
  return (
    <button
      onKeyPress={onKeyPress}
      // key={typeof(title) === 'string' ?title:refName}
      disabled={disabled || loading}
      onClick={onClick}
      type="button"
      className={typeState}
    >
      <div
        className={`flex w-auto text-sm text-center items-center ${
          title && 'md:space-s-1'
        }`}
      >
        {(loading && <BiLoaderAlt className="animate-spin w-5" />) || (
          <div className="flex items-center ">
            {(prefix && prefix) ||
              (Icon && <Icon className="  xl:h-5 xl:w-5 md:h-4  md:w-4" />)}
          </div>
        )}
        <div
          className={`${
            Icon ? 'md:block hidden' : 'flex'
          }  items-center flex-none`}
        >
          <span>
            {typeof title === 'string' ? (
              <ReturnTranslatedText
                origintext={title}
                text={`buttons.${title}`}
              />
            ) : (
              title
            )}
          </span>
        </div>
        <div className="flex items-center ">{suffix && suffix}</div>
      </div>
    </button>
  );
};

export default Button;
